const API_BASE = "https://signature-api.contractcandles.com";
const PROFILE_FIELDS = [
    "displayName",
    "jobTitle",
    "signOff",
    "mobilePhone",
    "businessPhone",
    "streetAddress",
    "city",
    "state",
    "postalCode",
];
// LaunchEvent handlers await these fetches before calling event.completed(),
// so a hung socket (host up but black-holing, DNS-resolves-but-dead) would
// stall Outlook's compose indefinitely instead of failing over to the cached
// signature. Abort after a short deadline so the catch path runs promptly.
const FETCH_TIMEOUT_MS = 6000;
async function fetchWithTimeout(input, init) {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), FETCH_TIMEOUT_MS);
    try {
        return await fetch(input, { ...init, signal: ctrl.signal });
    }
    finally {
        clearTimeout(timer);
    }
}
function buildQuery(opts = {}) {
    const qs = new URLSearchParams();
    if (opts.fromAddress)
        qs.set("from", opts.fromAddress);
    if (opts.forceMhfa)
        qs.set("mhfa", "1");
    if (opts.forceDisclaimer)
        qs.set("disclaimer", "1");
    if (opts.brandOverride)
        qs.set("brand", opts.brandOverride);
    if (opts.forceTuv)
        qs.set("tuv", "1");
    for (const k of PROFILE_FIELDS) {
        const v = opts[k];
        if (v != null)
            qs.set(k, v);
    }
    const s = qs.toString();
    return s ? `?${s}` : "";
}
export async function fetchMe(officeToken) {
    const res = await fetchWithTimeout(`${API_BASE}/api/me`, {
        headers: { Authorization: `Bearer ${officeToken}` },
    });
    if (!res.ok) {
        const body = await res.text();
        throw new Error(`/api/me ${res.status}: ${body.slice(0, 300)}`);
    }
    return (await res.json());
}
export async function fetchSignature(officeToken, opts) {
    const res = await fetchWithTimeout(`${API_BASE}/api/signature/me${buildQuery(opts)}`, { headers: { Authorization: `Bearer ${officeToken}` } });
    if (!res.ok) {
        const body = await res.text();
        throw new Error(`signature-api ${res.status}: ${body.slice(0, 300)}`);
    }
    return (await res.json());
}
